<script setup lang="ts">
import type { IProps } from './'
import SidebarMenuItem from './SidebarMenuItem.vue'

const props = defineProps<IProps>()
const route = useRoute()
</script>

<template>
  <div class="space-y-2">
    <SidebarMenuItem
      v-for="(sectionLink, index) in props.menuItems"
      :key="index"
      :url="sectionLink.url"
      :icon="sectionLink.icon"
      :class="{ 'text-blue-600': route.path.replace(/^\/ky/, '') === sectionLink.url }"
    >
      {{ sectionLink.title }}
    </SidebarMenuItem>
  </div>
</template>
